import { useAppSelector } from "Redux/hooks";
import ConditionComposer from "./ConditionComposer";
import ConditionEquation from "./ConditionEquation";
import { selectCurrentModule } from "Redux/ProducerSlice";

/*
  @function StepCondition
  render composer and equation, for the current step
  @params chapter {int} - chapter of step
  @params step {int} - number of step
  @returns {React.Node}
*/
export default function StepCondition({
  chapter,
  step,
}: {
  chapter: number;
  step: number;
}) {
  const currentModule = useAppSelector(selectCurrentModule);

  if (!currentModule) return null;

  if (currentModule.chapters[chapter]) {
    if (currentModule.chapters[chapter].questions[step]) {
      const stepObj = currentModule.chapters[chapter].questions[step];
      const trigger =
        typeof stepObj.trigger === "string"
          ? JSON.parse(stepObj.trigger)
          : stepObj.trigger;

      return (
        <div className="">
          <ConditionComposer
            condition={trigger}
            step={step}
            chapter={chapter}
          />
          <ConditionEquation condition={trigger} />
        </div>
      );
    }
  }

  return <div></div>;
}
